import {getLocale} from "../../i18n";
import {formatNumberLocalized} from '../number';

const MAX_NUM = 2 * Math.pow(10, 9);

function formatInteger(value) {
    return formatNumberLocalized(value, 0);
}

function formatDecimal(value) {
    return formatNumberLocalized(value, 2);
}

function formatSimpleDecimal(value) {
    return formatNumberLocalized(value, 1);
}

function formatPercent(value) {
    return formatNumberLocalized(value, 2) + '%';
}

function formatIntPercent(value) {
    return formatNumberLocalized(value, 0) + '%';
}

function formatVnd(value) {
    if (getLocale() === 'vi') {
        return formatNumberLocalized(value, 0) + '\u00A0₫';
    } else {
        return '₫' + formatNumberLocalized(value, 0);
    }
}

function formatLongVnd(value) {
    if (getLocale() === 'vi') {
        return formatNumberLocalized(value, 0) + '\u00A0VNĐ';
    } else {
        return formatNumberLocalized(value, 0) + '\u00A0VND';
    }
}

export {
    MAX_NUM,
    formatInteger,
    formatDecimal,
    formatSimpleDecimal,
    formatVnd,
    formatLongVnd,
    formatPercent,
    formatIntPercent
};
